<template>
  <div class="page-contact">
    <div class="container">
      <div class="section-head">
        <span class="section-label">CONTACT US</span>
        <h2 class="section-title">联系我们</h2>
        <p class="section-title-en">Feel Free to Contact Us Anytime</p>
        <div class="title-divider"></div>
      </div>
      <p class="section-desc">有任何需求或疑问，欢迎随时与我们联系</p>

      <div class="contact-layout">
        <!-- 联系信息 -->
        <div class="contact-info">
          <div class="info-card">
            <div class="info-icon">
              <svg viewBox="0 0 24 24" fill="currentColor"><path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.02-.24c1.12.37 2.33.57 3.57.57a1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.45.57 3.57a1 1 0 01-.25 1.02l-2.2 2.2z"/></svg>
            </div>
            <div>
              <h4>联系电话</h4>
              <p class="footer-highlight">13390873271</p>
            </div>
          </div>
          <div class="info-card">
            <div class="info-icon">
              <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a7 7 0 00-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 00-7-7zm0 9.5A2.5 2.5 0 1112 6.5a2.5 2.5 0 010 5z"/></svg>
            </div>
            <div>
              <h4>公司地址</h4>
              <p>江苏省苏州市昆山市玉山镇富士康路758-5号</p>
            </div>
          </div>
          <div class="info-card">
            <div class="info-icon">
              <svg viewBox="0 0 24 24" fill="currentColor"><path d="M20 6h-4V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2H4a2 2 0 00-2 2v11a2 2 0 002 2h16a2 2 0 002-2V8a2 2 0 00-2-2zm-10-2h4v2h-4V4z"/></svg>
            </div>
            <div>
              <h4>公司信息</h4>
              <p>昆山凡志红五金有限公司</p>
              <p>法定代表人：秦志成 · 注册资本：100万元整</p>
            </div>
          </div>
          <div class="info-card">
            <div class="info-icon">
              <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a10 10 0 100 20 10 10 0 000-20zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>
            </div>
            <div>
              <h4>工作时间</h4>
              <p>周一至周日 9:00 - 23:00</p>
            </div>
          </div>
          <div class="info-card">
            <div class="info-icon">
              <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a10 10 0 100 20 10 10 0 000-20zm-1 17.93A8.001 8.001 0 014 12c0-4.42 3.58-8 8-8s8 3.58 8 8-3.58 8-8 8v-2.93a6 6 0 010-10.14V2.07z"/></svg>
            </div>
            <div>
              <h4>官方网站</h4>
              <p>www.ksfzhwj.top</p>
            </div>
          </div>
        </div>

        <!-- 留言表单 -->
        <div class="contact-form">
          <h3>在线留言</h3>
          <p class="form-sub">请留下您的需求，我们将尽快与您联系</p>
          <div class="form-group">
            <label>姓名 <span class="required">*</span></label>
            <input v-model="form.name" type="text" placeholder="请输入您的姓名" />
          </div>
          <div class="form-group">
            <label>手机号 <span class="required">*</span></label>
            <input v-model="form.phone" type="tel" placeholder="请输入您的手机号" maxlength="11" />
          </div>
          <div class="form-group">
            <label>公司名称</label>
            <input v-model="form.company" type="text" placeholder="请输入您的公司名称（选填）" />
          </div>
          <div class="form-group">
            <label>留言内容</label>
            <textarea v-model="form.content" rows="4" placeholder="请描述您的需求..."></textarea>
          </div>
          <button class="btn btn-primary btn-block" @click="handleSubmit" :disabled="submitting">
            {{ submitting ? '提交中...' : '提交留言' }}
          </button>
          <p v-if="successMsg" class="success-msg">{{ successMsg }}</p>
          <p v-if="errorMsg" class="error-msg">{{ errorMsg }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { submitMessage } from '../api/portal'

export default {
  name: 'Contact',
  data() {
    return {
      form: {
        name: '',
        phone: '',
        company: '',
        content: ''
      },
      submitting: false,
      successMsg: '',
      errorMsg: ''
    }
  },
  methods: {
    async handleSubmit() {
      this.successMsg = ''
      this.errorMsg = ''

      if (!this.form.name.trim()) {
        this.errorMsg = '请填写姓名'
        return
      }
      if (!this.form.phone.trim()) {
        this.errorMsg = '请填写手机号'
        return
      }
      if (!/^1[3-9]\d{9}$/.test(this.form.phone.trim())) {
        this.errorMsg = '请输入正确的手机号'
        return
      }

      this.submitting = true
      try {
        const res = await submitMessage({
          name: this.form.name.trim(),
          phone: this.form.phone.trim(),
          company: this.form.company.trim(),
          content: this.form.content.trim()
        })
        if (res.data.success) {
          this.successMsg = '留言提交成功，我们会尽快与您联系！'
          this.form = { name: '', phone: '', company: '', content: '' }
        } else {
          this.errorMsg = res.data.message || '提交失败'
        }
      } catch (e) {
        this.errorMsg = '网络请求失败，请稍后重试'
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>
